import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { Alert } from "@/components/ui/Feedback";
import { PageHeader } from "@/components/ui/PageHeader";
import { importsApi } from "@/lib/imports-api";

import { BatchesCard } from "./BatchesCard";
import { DumpFilesCard } from "./DumpFilesCard";
import { JobsCard } from "./JobsCard";
import { UploadCard } from "./UploadCard";

export function ImportsPage() {
  const { t } = useTranslation();
  const overview = useQuery({
    queryKey: ["imports", "overview"],
    queryFn: importsApi.overview,
    refetchInterval: 15_000,
  });

  return (
    <>
      <PageHeader title={t("imports.title")} />
      <div className="space-y-6">
        {overview.data && !overview.data.worker_alive && <Alert>{t("imports.workerDown")}</Alert>}
        <UploadCard />
        <DumpFilesCard overview={overview.data} />
        <JobsCard />
        <BatchesCard />
      </div>
    </>
  );
}
